<template>
  <div class="container-fluid bg-gradient-theme">
    <div class="container">
      <div class="row min-vh-100 justify-content-center align-items-center">
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-10">
          <form class="user" @submit.prevent="auth">
            <div class="card o-hidden border-0 shadow-lg">
              <div class="card-body">
                <img
                  src="@/assets/img/senar.png"
                  class="img-fluid mt-2 mb-3"
                  alt="Logo"
                />
                <h4 class="text-center">REGISTROS DA QUALIDADE</h4>
                <div class="form-group">
                  <label>USUÁRIO</label>
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': $v.usuario.$error }"
                    placeholder="Usuário do RM TOTVS"
                    v-model="$v.usuario.$model"
                  />
                  <span v-if="!$v.usuario.required" class="invalid-feedback">
                    O usuário é obrigatório
                  </span>
                </div>
                <div class="form-group mb-4">
                  <label>SENHA</label>
                  <input
                    type="password"
                    class="form-control"
                    :class="{ 'is-invalid': $v.password.$error }"
                    placeholder="Senha"
                    v-model="$v.password.$model"
                  />
                  <span v-if="!$v.password.required" class="invalid-feedback">
                    A senha é obrigatória
                  </span>
                </div>
                <button
                  type="submit"
                  class="btn btn-theme btn-user btn-block mb-2"
                  title="Login"
                  :disabled="$v.$invalid || disableButton"
                >
                  <span v-if="disableButton">
                    <i class="fas fa-spinner fa-spin" />
                  </span>
                  <span v-else>LOGIN</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import PATHS from '@/router/routesMap'

export default {
  name: 'Auth',

  data() {
    return {
      usuario: '',
      password: '',
      disableButton: false,
    }
  },

  methods: {
    async auth() {
      if (!this.$v.$invalid) {
        this.disableButton = true
        try {
          await this.$store.dispatch('auth', {
            usuario: this.usuario,
            password: this.password,
          })

          this.disableButton = false
          this.$router.push(PATHS.HOME)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$snotify.warning(error.message, 'Atenção!')
          } else {
            this.$snotify.error(
              'Não foi possível se conectar ao servidor.',
              'Erro!',
            )
          }
        }
      }
    },
  },

  validations: {
    usuario: {
      required,
    },
    password: {
      required,
    },
  },
}
</script>
